import { render } from "./Extraction.vue?vue&type=template&id=61bc38ff"
import script from "./Extraction.vue?vue&type=script&lang=js"
export * from "./Extraction.vue?vue&type=script&lang=js"

import "./Extraction.vue?vue&type=style&index=0&id=61bc38ff&media=screen&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__